import VisualSection from './VisualSection';

export * from './VisualSection';

export default VisualSection;
